import React from 'react';
import PropTypes from 'prop-types';
import Loadable, { LoadingComponentProps, OptionsWithoutRender } from 'react-loadable';
import { GlobalLoadingCaller } from 'Utils/GlobalLoading';
import { Error } from 'Components/Errors/Error';
import { LoadError, promiseWithRetry, setPromiseWithRetryLogger } from 'Utils/promiseWithRetry';
import { DOMAIN, LoggerFactory } from 'Services/Logger';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface LoadableComponentProps extends Omit<OptionsWithoutRender<any>, 'loading'> {
  label: string;
}

// Configure Retry Logger
const logger = LoggerFactory.getLogger(DOMAIN.KUESKI);
setPromiseWithRetryLogger(logger);

const LoadingComponent: React.ComponentType<LoadingComponentProps> = ({ error }) => {
  if (error) {
    if (error instanceof LoadError && error.type === 'LOAD') window.location.reload();
    return <Error reason="LoadableError" />;
  }

  return <GlobalLoadingCaller />;
};

LoadingComponent.propTypes = {
  error: PropTypes.instanceOf(Object),
};

LoadingComponent.defaultProps = {
  error: null,
};

export const LoadableComponent = ({
  modules,
  loader,
  label,
  timeout,
  ...props
}: LoadableComponentProps) => Loadable({
  loader: () => promiseWithRetry(loader, label, timeout ? { timeout } : {}),
  modules,
  ...props,
  loading: LoadingComponent,
});
